// extracted by mini-css-extract-plugin
export default {"main":"pos_main__g0Xm3","secondTable":"pos_secondTable__D9ZRl","closeModal":"pos_closeModal__RrBqH","overlay":"pos_overlay__mMZU6","backgroundOverlay":"pos_backgroundOverlay__pQPca"};